export default "__VITE_ASSET__BNb7YVPm__"